interface Props {
  color?: string;
}

export function LinkedIn({ color = "#2F3942" }: Props): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 224 224"
      width="30px"
      height="30px"
    >
      <g fill={color}>
        <path d="M67.2,186.66667h-37.33333v-112h37.33333zM48.5408,59.73333c-10.3264,0 -18.67413,-8.37013 -18.67413,-18.67413c0,-10.304 8.36267,-18.6592 18.67413,-18.6592c10.28907,0 18.6592,8.37013 18.6592,18.6592c0,10.304 -8.37013,18.67413 -18.6592,18.67413zM201.6,186.66667h-35.89227v-54.50667c0,-12.99947 -0.2464,-29.71733 -18.6592,-29.71733c-18.68907,0 -21.56373,14.1568 -21.56373,28.77653v55.44747h-35.8848v-112.08213h34.4512v15.31413h0.48533c4.7936,-8.81067 16.5088,-18.0992 33.9808,-18.0992c36.36267,0 43.08267,23.21387 43.08267,53.39413z" />
      </g>
    </svg>
  );
}
